export const GLOBAL_TRACKING_URL = `${process.env.REACT_APP_API_URL}/t`;

export const GLOBAL_USER_URL = `${process.env.REACT_APP_API_URL}/user`;

export const GLOBAL_GENERAL_URL = `${process.env.REACT_APP_API_URL}/general`;
